exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-scroll[data-v-17db2b72] {\n  padding-right: 4px;\n}\n.list-scroll[data-v-17db2b72]::-webkit-scrollbar {\n  width: 4px;\n}\n.list-scroll[data-v-17db2b72]::-webkit-scrollbar-track {\n  background-color: #0000;\n}\n.list-scroll[data-v-17db2b72]::-webkit-scrollbar-thumb {\n  background-color: rgba(100, 100, 100, 0.2);\n  border-radius: 4px;\n}", ""]);

// exports
